    //import liraries
    import React from "react";
    import { View,  ScrollView, FlatList } from "react-native";
    import { CreateResponsiveStyle } from "rn-responsive-styles";
    import CText from "../../common/CText";
    import CustomButton from "../../common/CustomButton";
    import { COLORS, FONTS } from "../../constant";
    import CImage from "../../common/CImage";
    import { isEmpty } from "lodash";
    import { headingData,changeDateFormat } from "../../constant/dataHelper";

    // create a component
    const CTable = (props) => {
    
    const styles = useStyles();
    const transactionData = props?.txnData


    return (
        <View>
        
            {
            isEmpty(transactionData)
                ? <View style={{ alignItems: "center", justifyContent: "center", marginTop: 40, }}>
                <CImage.Ti24SCancelImage />
                <CText.kycTypeText
                    style={{ color: COLORS.black, paddingVertical: 20 }}
                >
                    {"No Transactions Found"}
                </CText.kycTypeText>
                <CText.kycTypeText
                    style={{
                    color: COLORS.black,
                    paddingBottom: 20,
                    opacity: 0.5,
                    fontFamily: FONTS.InterMedium,
                    paddingHorizontal: 60,
                    textAlign: "center",
                    }}
                >
                    {
                    "Sorry, no disputes were found on your account"
                    }
                </CText.kycTypeText>
                </View>
                : 
                <View
                style={styles.tableWarpper}>
                <ScrollView horizontal={true}>
                  <View
                    style={{
                      width: '100%',
                      borderRadius: 20,
                      justifyContent: 'center',
                      
                    }}>
                    <View style={styles.headerViewStyle}>
                      {headingData.map((item, index) => {
                        return (
                          <View style={styles.headerViewStyle} key={index}>
                            <CText.tiTransactionText style={{ width: item.width, minWidth: item.width }}>{item.title}</CText.tiTransactionText>
                            {item.showLine && <View style={styles.verticalLineStyle} />}
                          </View>
                        );
                      })}
                    </View>
                    <FlatList
                      showsVerticalScrollIndicator
                      data={transactionData}
                      showsHorizontalScrollIndicator
                      key = {(item, index) => index+"_"+item?.id?.toString() }
                      keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                      renderItem={({ item, index }) => {
                        return (
                          <View
                            style={[
                              styles.dataViewStyle,
                              {
                                backgroundColor: index % 2 !== 0 ? '#ffffff' : '#E5E5E5',
                                borderBottomRightRadius: index == transactionData.length - 1 ? 15 : null,
                                borderBottomLeftRadius: index == transactionData  .length - 1 ? 15 : null,
                              },
                            ]}>
                            <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>{item.vrn}</CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}>
                              { item.dateTime?.split(",")[0] }
                            </CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}>
                            {item.dateTime?.split(",")[1] }
                            </CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}>{item.transId}</CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 230, minWidth: 230 }}>{item.transactionType }</CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 230, minWidth: 230 }}>{item.tollPlaza}</CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}>{item.statementType == 'D' ? item.price : '-'}</CText.tiTransactionText>
                            <View style={styles.verticalLineStyle} />
                            <CText.tiTransactionText style={{ width: 125, minWidth: 125 }}>{item.statementType == 'C' ? item.price : '-'}</CText.tiTransactionText>
                          </View>
                        );
                      }}
                    />
                  </View>
                </ScrollView>
              </View>
            }

        </View>
    );
    };

    // define your styles
    const useStyles = CreateResponsiveStyle({
        tableWarpper:{
            width: 'auto',  height: 'auto', borderRadius: 15,
            backgroundColor: '#ffffff',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#d1d1d1',
            margin: 25,
          },
    
    headerViewStyle: {
        flexDirection: "row",
        backgroundColor: "#ffffff",
    },
    verticalLineStyle: {
        width: 0.5,
        height: "100%",
        backgroundColor: "#a0a0a0",
    },
    dataViewStyle: {
        flexDirection: "row",
    },
    
    });

    //make this component available to the app
    export default CTable;
